import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  triggerName: 'customer',
  namespace: 'CUSTOMER',
  entryPoint: '/customers',
  collectionName: 'customers',
  querySearchListing: [
    ['name', ['entity', ['primary_email'] ]],
    { order: { id: 'asc' } }
  ],
  quickSearch: (keyword) => ({ $any: [{ name: { match: keyword } }, { 'entity.primary_email': { match: keyword } }] }),
  successMessageCreate: 'Customer created',
  successMessageUpdate: 'Customer updated',
  successMessageDelete: 'Customer deleted',
});

export default {
  ...triggers,
  submitCustomer(dispatch, getState, { objectData, id }) {
    const { entity_data, ...data } = objectData;
    const entitiesCollectionName = data.entity.value[0];
    data.relations = { [entitiesCollectionName]: [entity_data] };
    return !id
      ? triggers.submitCreateForm(dispatch, getState, data)
      : triggers.submitEditForm(dispatch, getState, { id, objectData: data });
  }
};



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/customer/triggers.js